export enum ContactStatus {
  PENDING = 'PENDING',
  PLACED = 'PLACED',
  DIALING = 'DIALING',
  QUEUED = 'QUEUED',
  CONNECTED = 'CONNECTED',
  SUCCESS = 'SUCCESS',
  WAITING = 'WAITING',
  FAILED = 'FAILED',
  NOANSWER = 'NOANSWER',
  ABANDONED = 'ABANDONED',
  DELETED = 'DELETED',
  NOANSWER_AMD = 'NOANSWER_AMD',
}
